<template>
  <div class="tabs is-centered">
    <ul>
      <li>
        <router-link to="/lists">Lists</router-link>
      </li>
      <li>
        <router-link to="/scheduled">Scheduled</router-link>
      </li>
      <li>
        <router-link to="/settings">Settings</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "NavBar"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
ul {
  list-style-type: none;
  border: 0 !important;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: white;
}
</style>
